// extracted by mini-css-extract-plugin
export default {"container":"style_container__80oDi","aboutUsCont":"style_aboutUsCont__cVLEZ","visionMissionCont":"style_visionMissionCont__VYBAO","historyCont":"style_historyCont__NKSXK"};